import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import 'react-dates/initialize'
import { DateRangePicker } from 'react-dates'

import BkFlowEditDateToggle from './layouts/BkFlowEditDateToggle'
import BkFlowEditDateSelect from './layouts/BkFlowEditDateSelect'

import formatPrice from '../../../utilities/currency/formatPrice'
import yn from 'yn'
import _ from 'lodash'

import 'react-dates/lib/css/_datepicker.css'
import '../../../styles/css/components/edit/date/bk-flow-edit-stay-date.css'
import getCurrencySymbol from '../../../utilities/currency/getCurrencySymbol'

if (process.env.REACT_APP_COMPONENT_EDIT_STAY_DATE_LAYOUT === 'select') {
	require('../../../styles/css/components/edit/date/bk-flow-edit-stay-date-select.css')
} else {
	require('../../../styles/css/components/edit/date/bk-flow-edit-stay-date-toggle.css')
}

class BkFlowEditDatesField extends Component {
	constructor(props) {
		super(props)

		this.state = {
			focusedInput: null
		}
	}

	toggleCustomDate = ( dateField ) => {
		const targetDatePicker = 'js-datepicker__' + dateField
		document.getElementById(targetDatePicker).focus()
	}

	// Input focus event
	onFocusChange = ( focusedInput ) => {
		this.setState({ focusedInput })
	}

	render() {
		const {
			activeHotelCode,
			configData,
			endDate,
			onDatesChange,
			propertyAvailability,
			propertyAvailabilityLoading,
			startDate,
			urlData,
		} = this.props

		const { focusedInput } = this.state

		const hotelLabels = configData.hotel.labels[0]
		let flowQueryConfig = null

		if (
			localStorage &&
			localStorage.flowQueryConfig
		) {
			 flowQueryConfig = JSON.parse(localStorage.flowQueryConfig)
		}

		let currentProperty = null
		let propertyOpenDate = null
		let propertyCloseDate = null

		if (
			activeHotelCode &&
			flowQueryConfig &&
			flowQueryConfig.supportedProperties
		) {
			currentProperty = flowQueryConfig.supportedProperties.find(function (property) {
				return String(property.hotelCode) === String(activeHotelCode)
			})
		}

		if (currentProperty) {
			if (
				currentProperty.propertyOpenDate &&
				currentProperty.propertyOpenDate !== ''
			) {
				propertyOpenDate = moment(new Date(currentProperty.propertyOpenDate), 'MM-DD-YYYY')
			}

			if (
				currentProperty.propertyCloseDate &&
				currentProperty.propertyCloseDate !== ''
			) {
				propertyCloseDate = moment(new Date(currentProperty.propertyCloseDate), 'MM-DD-YYYY')
			}
		}

		const renderCalendarLegend = () => {
			if (yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROPERTY_AVAILABILITY)) {
				return (
					<div className="bk-flow-edit-stay__date-legend">
						<div className="bk-flow-edit-stay__date-legend-col">
							<span className="bk-flow-edit-stay__date-icon-unavailable"></span>
							<span className="bk-flow-edit-stay__date-content u-font-xxs">
								{ hotelLabels.unavailable ? hotelLabels.unavailable : 'Unavailable' }
							</span>
						</div>
						<div className="bk-flow-edit-stay__date-legend-col">
							<span className="bk-flow-edit-stay__date-icon-available"></span>
							<span className="bk-flow-edit-stay__date-content u-font-xxs">
								{ hotelLabels.available ? hotelLabels.available : 'Available' }
							</span>
						</div>
						<div className="bk-flow-edit-stay__date-legend-col">
							<span className="bk-flow-edit-stay__date-icon-selected"></span>
							<span className="bk-flow-edit-stay__date-content u-font-xxs">
								{ hotelLabels.selected ? hotelLabels.selected : 'Selected' }
							</span>
						</div>
					</div>
				)
			}
		}

		// Match currentDate to availability dates and retrieve closed flag
		const isDayBlocked = day => {
			if (propertyAvailability) {
				const formattedDate = day.format('YYYY-MM-DD')
				const currentDate = propertyAvailability[activeHotelCode + '-' + formattedDate]
				const isRangeStart = _.get(currentDate, 'isRangeStart')

				if (currentDate && focusedInput === 'endDate' && isRangeStart) {
					return false
				} else if (currentDate) {
					return currentDate.isClosedForArrival
				}
			}

			return false
		}

		const renderDay = (day) => {
			let dates = []

			if (propertyAvailability) {
				const formattedDate = day.format('YYYY-MM-DD')
				const currentDate = propertyAvailability[activeHotelCode + '-' + formattedDate]
				const currencyCode = _.get(currentDate, 'pricing[0].currency', 'USD')
				const currencySymbol = getCurrencySymbol(currencyCode)

				if (
					currentDate &&
					currentDate.pricing &&
					currentDate.pricing[0] &&
					currentDate.pricing[0].price
				) {
					dates.push(
						<div
							key={day}
							className="u-cal__custom-cell"
						>
							<p className="u-remove-margin date">{moment(day).format('D')}</p>
							<p className="u-font-bold u-remove-margin price">{currencySymbol}{ formatPrice(currentDate.pricing[0].price, 0) }</p>
						</div>
					)
				} else if (
					!currentDate && propertyAvailabilityLoading
				) {
					dates.push(
						<div
							key={day}
							className="u-cal__custom-cell"
						>
							<p className="u-remove-margin date">{moment(day).format('D')}</p>
							<p className="u-font-bold u-remove-margin price price--loading">$999</p>
						</div>
					)
				} else {
					dates.push(moment(day).format('D'))
				}
			} else {
				dates.push(moment(day).format('D'))
			}

			return dates
		}



		const handleMonthChange = (calendarDate) => {
			const {
				activeHotelCode,
				calendarAvailabilityEvent,
				calendarAvailEnd
			} = this.props

			const currentCalendarMonth = moment(calendarDate, 'YYYY-MM-DD')
			const currentAvailEnd = moment(calendarAvailEnd, 'YYYY-MM-DD')

			if (currentCalendarMonth.isAfter(currentAvailEnd)) {
				const updatedCalendarAvailStart = moment(calendarAvailEnd, 'YYYY-MM-DD').add(5, 'days').startOf('month').format('YYYY-MM-DD')
				const updatedCalendarAvailEnd = moment(updatedCalendarAvailStart, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')

				calendarAvailabilityEvent(updatedCalendarAvailStart, updatedCalendarAvailEnd, activeHotelCode, '')
			}
		}

		return (
			<div className="bk-flow-edit-stay__date-pick-container">
				<DateRangePicker
					customArrowIcon={ <span className="u-element-hidden"></span> }
					daySize={ 33 }
					displayFormat='YYYY-MM-DD'
					endDate={ endDate }
					endDateId="js-datepicker__departure"
					focusedInput={ focusedInput }
					horizontalMargin={ 30 }
					isDayBlocked={ isDayBlocked }
					isOutsideRange={ propertyOpenDate && propertyCloseDate ?
						date => date.isSame(propertyOpenDate) || date.isBetween(propertyCloseDate, propertyOpenDate) || date.isSame(propertyCloseDate)
					:
						date => date.isBefore(moment().subtract(1, 'days')) || date.isAfter(moment().add(18, 'months'))
					}
					navNext={ <i className="material-icons">arrow_right</i> }
					navPrev={ <i className="material-icons">arrow_left</i> }
					noBorder={ true }
					numberOfMonths={ 1 }
					onDatesChange={ onDatesChange }
					onFocusChange={ this.onFocusChange }
					onPrevMonthClick={(date) => handleMonthChange(date)}
					onNextMonthClick={(date) => handleMonthChange(date)}
					renderCalendarInfo={ renderCalendarLegend }
					renderDayContents={(day) => renderDay(day)}
					startDate={ startDate }
					startDateId="js-datepicker__arrival"
				/>

				{process.env.REACT_APP_COMPONENT_EDIT_STAY_DATE_LAYOUT === 'select' ?
					<Fragment>
						<BkFlowEditDateSelect
							initialDate={urlData.endDate}
							activeDateValue={startDate}
							dateField="arrival"
							fieldLabel={ hotelLabels.checkIn ? hotelLabels.checkIn : 'Check In'}
							toggleDateEvent={this.toggleCustomDate}
						/>
						<BkFlowEditDateSelect
							initialDate={urlData.endDate}
							activeDateValue={endDate}
							dateField="departure"
							fieldLabel={ hotelLabels.checkOut ? hotelLabels.checkOut : 'Check Out'}
							toggleDateEvent={this.toggleCustomDate}
						/>
					</Fragment>
				:
					<Fragment>
						<BkFlowEditDateToggle
							initialDate={urlData.startDate}
							activeDateValue={startDate}
							dateField="arrival"
							fieldLabel={ hotelLabels.checkIn ? hotelLabels.checkIn : 'Check In'}
							toggleDateEvent={this.toggleCustomDate}
						/>
						<BkFlowEditDateToggle
							initialDate={urlData.endDate}
							activeDateValue={endDate}
							dateField="departure"
							fieldLabel={ hotelLabels.checkOut ? hotelLabels.checkOut : 'Check Out'}
							toggleDateEvent={this.toggleCustomDate}
						/>
					</Fragment>
				}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	activeHotelCode: state.editStayPropertyData.activeHotelCode,
	propertyAvailability: state.propertyAvailabilityData.availability,
	propertyAvailabilityLoading: state.propertyAvailabilityData.loading,
	urlData: state.availabilityData.urlData
})

export default connect(mapStateToProps, null)(BkFlowEditDatesField)


// WEBPACK FOOTER //
// ./src/components/edit/dates/BkFlowEditDatesField.js